import React from "react";
import { Box } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Undo as UndoIcon } from "@mui/icons-material";
import StatusBadge from "./StatusBadge";

const EmployeeTable = ({
  currentRows = [],
  onDelete,
  onUndo,
  page = 1,
  rowsPerPage = 10
}) => {
  const safePage = Number(page) || 1;
  const safeRowsPerPage = Number(rowsPerPage) || 10;

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
      }}
    >
      <table
        className="pd-table"
        style={{
          width: "100%",
          tableLayout: "auto",
          borderCollapse: "collapse"
        }}
      >
        <thead>
          <tr>
            <th style={{ width: "10%" }}>S.No</th>
            <th style={{ width: "30%" }}>Employee Name</th>
            <th style={{ width: "25%" }}>Department</th>
            <th style={{ width: "20%" }}>Status</th>
            <th style={{ width: "15%" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {currentRows.length > 0 ? (
            currentRows.map((user, index) => {
              const displayStatus = user.isAssignedElsewhere
                ? "Already Assigned"
                : user.assessmentStatus || "Available";
              const isAvailable = user.isActive && displayStatus === "Available";

              return (
              <tr
                key={user.id || index}
                style={{
                  opacity: isAvailable ? 1 : 0.5,
                  backgroundColor: isAvailable ? "inherit" : "#f5f5f5"
                }}
              >
                {/* S.No */}
                <td>
                  {(safePage - 1) * safeRowsPerPage + index + 1}
                </td>

                {/* Employee Name */}
                <td
                  title={user.employeeName}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {user.employeeName}
                </td>

                {/* Department */}
                <td
                  title={user.departmentName}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {user.departmentName || "None"}
                </td>

                <td>
                  <StatusBadge status={displayStatus} />
                </td>

                {/* Action */}
                <td>
                  {user.isActive ? (
                    <button
                      className="action-icon"
                      onClick={() => onDelete(user.id)}
                      title="Delete"
                    >
                      <DeleteIcon fontSize="small" />
                    </button>
                  ) : (
                    <button
                      className="action-icon"
                      onClick={() => onUndo(user.id)}
                      title="Undo"
                    >
                      <UndoIcon fontSize="small" />
                    </button>
                  )}
                </td>
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5} align="center" style={{ padding: "1rem" }}>
                No employees in Individual Employees List
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default EmployeeTable;
